import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import { retryPayment } from "api/payments";
import React from "react";
import { toast } from "react-hot-toast";
import { MdHighlightOff, MdOutlineRefresh } from "react-icons/md";
import { convertToFloat } from "utils/formatNumber";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";
import { PANEL_STYLES } from "./InfoModal";

const RetryModal = ({
  info, fetchPayments, transactionID, varient, enRefund, client_is_deleted,
}: {
  info?: any; fetchPayments: () => void; transactionID: string;
  varient?: string; enRefund?: any; client_is_deleted?: boolean;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = React.useState<boolean>();
  const [isCloseModal, setIsCloseModal] = React.useState(false);
  const [popoverOpen, setPopoverOpen] = React.useState(false);

  const handleClose = () => { setIsCloseModal(true); setTimeout(() => { setIsCloseModal(false); onClose(); }, 300); };

  const isDisabled =
    client_is_deleted || info?.client === "Banwire" || info?.id?.includes("payout") ||
    ["REFUNDED","REJECTED","CREATED","AUTHORIZED","PENDING","CAPTURED","APPROVED",
     "CHARGEBACK","ALERTED","HELD","DUPLICATE","DISPUTE","REFUND DECLINED"].includes(info?.status);

  async function handleRetry() {
    setIsLoading(true);
    retryPayment({ internal_id: transactionID }, info.clientId)
      .then((resp: any) => {
        if (resp.errors) toast.error(resp.errors[0].message);
        else toast.success("Retry payment successful");
        onClose(); fetchPayments();
      })
      .catch((err: any) => toast.error(err?.response?.data?.error ?? "Unable to retry transaction"))
      .finally(() => setIsLoading(false));
  }

  return (
    <>
      <span className="inline-flex">
        <button className="txn-action-btn" onClick={onOpen} disabled={isDisabled} aria-label="Retry" onMouseEnter={() => !isOpen && setPopoverOpen(true)} onMouseLeave={() => setPopoverOpen(false)}>
          <MdOutlineRefresh size={14} />  <span>Retry Payment</span>
        </button>
      </span>
      

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`pconfirm-panel${isOpen && !isCloseModal ? " pconfirm-panel--open" : " pconfirm-panel--close"}`}>
          <div className="pconfirm-glow pconfirm-glow--amber" />
          <div className="pconfirm-header pconfirm-header--amber">
            <div className="pconfirm-header-brand">
              <div className="pconfirm-header-logo">
                <MdOutlineRefresh size={20} color="#fff" />
              </div>
              <div>
                <h2 className="pconfirm-title">Retry Payment</h2>
                <p className="pconfirm-sub">Re-attempt the transaction</p>
              </div>
            </div>
            <button className="pconfirm-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
          </div>

          <div className="pconfirm-body">
            <div className="pconfirm-info-card">
              <div className="pconfirm-info-row">
                <span className="pconfirm-info-key">Internal ID</span>
                <span className="pconfirm-info-val">{info?.id || "—"}</span>
              </div>
              <div className="pconfirm-info-row">
                <span className="pconfirm-info-key">Amount</span>
                <span className="pconfirm-info-val pconfirm-info-val--amount">
                  {convertToFloat(info?.amount)} {info?.currency}
                </span>
              </div>
            </div>
            <p className="pconfirm-question">
              This will retry the failed transaction. The payment will be attempted again using the original details. Do you want to continue?
            </p>
          </div>

          <div className="pconfirm-footer">
            <button className="pconfirm-btn-cancel" onClick={handleClose}>Cancel</button>
            <button
              className="pconfirm-btn-action--amber"
              onClick={handleRetry}
              disabled={!!isLoading || client_is_deleted}
            >
              {isLoading ? (
                <span className="pconfirm-spinner" />
              ) : (
                <><MdOutlineRefresh size={14} />Retry</>
              )}
            </button>
          </div>
        </div>
      </Modal>

      {PANEL_STYLES}
    </>
  );
};

export default RetryModal;